import PropTypes from 'prop-types';
import breakPoints from 'helpers/Styles';
import PrimaryButton from '../PrimaryButton';

const MyDetails = ({ customer, handleEdit }) => {
  const name = `${customer?.firstName} ${customer?.lastName}`;
  const email = customer?.email;
  const phone = customer?.phone ? customer?.phone : '';
  const address = customer?.defaultAddress
    ? `${customer?.defaultAddress?.address1} ${customer?.defaultAddress?.city} ${customer?.defaultAddress?.province} ${customer?.defaultAddress?.zip} ${customer?.defaultAddress?.country}`
    : '';

  const handleEditDetails = () => {
    handleEdit(true);
  };

  return (
    <>
      {customer && (
        <div className="my_details">
          <div className="details-information">
            <div className="detail-group">
              <div className="label">Name</div>
              <div className="value capitalize">{name || '-'}</div>
            </div>
            <div className="detail-group">
              <div className="label">Email</div>
              <div className="value">{email || '-'}</div>
            </div>
            <div className="detail-group">
              <div className="label">Phone</div>
              <div className="value">{phone || '-'}</div>
            </div>
            <div className="detail-group">
              <div className="label">Address</div>
              {address !== undefined && (
                <div className="value">{address || '-'}</div>
              )}
            </div>
            <div className="detail-group">
              <div />
              <div className="button_container">
                <PrimaryButton
                  text={'EDIT DETAILS'}
                  onClick={handleEditDetails}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <style jsx>{`
        .my_details {
          margin-top: 40px;
        }
        .capitalize {
          text-transform: capitalize;
        }
        .button_container {
          margin-top: 40px;
        }
        .detail-group {
          display: flex;
          gap: 5px;
          margin-bottom: 16px;
        }
        .value {
          font-family: 'Roboto-Medium';
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: left;

          color: #e4e4e4;
        }
        .label {
          font-family: 'Roboto-Medium';
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: left;

          color: #949494;
          min-width: 112px;
        }
      `}</style>
    </>
  );
};

MyDetails.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  customer: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
};

export default MyDetails;
